import AddPhoneModal from './addPhoneModal.view';

export default AddPhoneModal;
